<!-- no suitable products matched section starts-->
<ng-container>
    <div class="tw-px-[25px] md:tw-px-[55px] tw-pt-0">
        <div class="product-card tw-mt-10 tw-pb-10 tw-w-full">
            <div class="tw-flex tw-items-center tw-w-full">
                <div class="sme-loan--not-eligible">
                    <div>
                        <div
                            class="tw-flex tw-flex-col md:tw-flex-row tw-gap-[24px]"
                        >
                            <div class="tw-w-auto md:tw-w-[525px]">
                                <div
                                    class="!tw-mb-[10px] tw-font-semibold tw-pt-[6px]"
                                >
                                    {{ "NON_ELIGIBLE_MSG_TITLE" | translate }}
                                </div>
                                <div
                                    class="!tw-mb-[10px] tw-font-[500] tw-pt-[20px] tw-text-[16px] tw-text-[#7B7575] tw-leading-[24px]"
                                >
                                    {{
                                        "NON_ELIGIBLE_MSG_SUBTITLE_1"
                                            | translate
                                    }}
                                </div>
                                <div
                                    class="!tw-mb-[10px] tw-font-[500] tw-pt-[20px] tw-text-[16px] tw-text-[#7B7575] tw-leading-[24px]"
                                >
                                    {{
                                        "NON_ELIGIBLE_MSG_SUBTITLE_2"
                                            | translate
                                    }}
                                    <span
                                        class="tw-text-blue-600 dark:tw-text-blue-500 hover:tw-underline"
                                    >
                                        <a href="mailto:imsme@cgc.com.my">{{
                                            "imsme@cgc.com.my"
                                        }}</a> </span
                                    >.
                                </div>
                                <div
                                    class="tw-items-center tw-max-w-[200px] tw-w-full tw-pt-[40px]"
                                >
                                    <button
                                        ga-event-id="back_to_imsme_no_product_match_click"
                                        ga-event-category="No Product Match Button"
                                        ga-event-label="Back to imSME Button"
                                        ga-track="track"
                                        class="tw-text-[18px] tw-leading-[20px] tw-w-full tw-text-center tw-font-[600] tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300 tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                                        (click)="goToHome()"
                                    >
                                        {{ "BACK_TO_IMSME" | translate }}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <img
                                    class="tw-w-[100%]"
                                    src="../../../assets/images/side.png"
                                    alt="side image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<!-- no suitable products matched section ends-->
